import { render, staticRenderFns } from "./branchServices.vue?vue&type=template&id=775b3eac&"
import script from "./branchServices.vue?vue&type=script&lang=js&"
export * from "./branchServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports